import Icon from "@cloudscape-design/components/icon"
import { colorTextStatusInactive } from "@cloudscape-design/design-tokens"

interface TimelineDotIconProps {
  /**
   * "primary" is the solid brand-orange dot for state changes and creation; "muted" is a smaller
   * grey dot for in-stage events (edits, approvals) that don't move the DTA between stages.
   */
  variant?: "primary" | "muted"
}

/**
 * Dot marker (Cloudscape Icon) for a timeline/step. Orange for stage changes, grey for in-stage
 * events.
 */
const TimelineDotIcon = ({ variant = "primary" }: TimelineDotIconProps) => {
  const muted = variant === "muted"
  return (
    // Cloudscape colors icons via `currentColor`; set color here so the dot's fill/stroke inherit it.
    <span style={{ color: muted ? colorTextStatusInactive : "var(--color-primary)" }}>
      <Icon
        size="small"
        svg={
          <svg viewBox="0 0 16 16" focusable="false" aria-hidden="true">
            <circle cx="8" cy="8" r={muted ? 2 : 3} fill="currentColor" stroke="currentColor" />
          </svg>
        }
      />
    </span>
  )
}

export default TimelineDotIcon
